import type { Analytics, AnalyticsData } from '@mwl/core-lib';

import type { FilterTypes, GetFilterPopupAnalytics } from './FilterPopup.types';

export const getFilterPopupAnalytics: GetFilterPopupAnalytics = ({ filterType, filterItem, filterItems }) => {
  const analyticsData: AnalyticsData = {
    text: filterItem.title,
    ...(filterType === 'championship' ? { count: filterItems.length } : {}),
    ...(filterType === 'championship'
      ? { position: filterItems.findIndex((filter) => filter.id === filterItem.id) + 1 }
      : {}),
  };

  return {
    filterPopupAnalytics: {
      check: {
        eventName:
          filterType === 'category'
            ? 'sportFilter_sportCategory_list_select'
            : 'sportFilter_sportChampionship_list_select',
        data: analyticsData,
      },
      uncheck: {
        eventName:
          filterType === 'category'
            ? 'sportFilter_sportCategory_list_unselect'
            : 'sportFilter_sportChampionship_list_unselect',
        data: analyticsData,
      },
    },
  };
};

export const filterBackAnalytics: Analytics<'click'> = {
  click: { eventName: 'sportFilter_back_icon_click', data: {} },
};

export const filterChooseAllCategoryAnalytics: Analytics<'click'> = {
  click: { eventName: 'sportFilter_sportCategory_chooseAll_btn_click', data: {} },
};

export const filterClearAllCategoryAnalytics: Analytics<'click'> = {
  click: { eventName: 'sportFilter_sportCategory_сlearAll_btn_click', data: {} },
};

export const filterCategorySelectAnalytics: Analytics<'click'> = {
  click: { eventName: 'sportFilter_sportCategory_list_select', data: {} },
};

export const filterCategoryUnselectAnalytics: Analytics<'click'> = {
  click: { eventName: 'sportFilter_sportCategory_list_unselect', data: {} },
};

export const filterApplyCategoryAnalytics: Analytics<'click'> = {
  click: { eventName: 'sportFilter_sportCategory_applayFilter_btn_click', data: {} },
};

export const filterChipCategoryAnalytics: Analytics<'click'> = {
  click: { eventName: 'sportFilter_sportCategory_xIcon_unselect', data: {} },
};

export const filterChooseAllChampionshipAnalytics: Analytics<'click'> = {
  click: { eventName: 'sportFilter_sportChampionship_chooseAll_btn_click', data: {} },
};

export const filterClearAllChampionshipAnalytics: Analytics<'click'> = {
  click: { eventName: 'sportFilter_sportChampionship_сlearAll_btn_click', data: {} },
};

export const filterChampionshipSelectAnalytics: Analytics<'click'> = {
  click: { eventName: 'sportFilter_sportChampionship_list_select', data: {} },
};

export const filterChampionshipUnselectAnalytics: Analytics<'click'> = {
  click: { eventName: 'sportFilter_sportChampionship_list_unselect', data: {} },
};

export const filterApplyChampionshipAnalytics: Analytics<'click'> = {
  click: { eventName: 'sportFilter_sportChampionship_applayFilter_btn_click', data: {} },
};

export const filterChipChampionshipAnalytics: Analytics<'click'> = {
  click: { eventName: 'sportFilter_sportChampionship_xIcon_unselect', data: {} },
};

export const filterPopupButtonsAnalytics: Record<FilterTypes, Record<string, Analytics<'click'>>> = {
  category: {
    chip: filterChipCategoryAnalytics,
    chooseAll: filterChooseAllCategoryAnalytics,
    clearAll: filterClearAllCategoryAnalytics,
    select: filterCategorySelectAnalytics,
    unselect: filterCategoryUnselectAnalytics,
    apply: filterApplyCategoryAnalytics,
  },
  championship: {
    chip: filterChipChampionshipAnalytics,
    chooseAll: filterChooseAllChampionshipAnalytics,
    clearAll: filterClearAllChampionshipAnalytics,
    select: filterChampionshipSelectAnalytics,
    unselect: filterChampionshipUnselectAnalytics,
    apply: filterApplyChampionshipAnalytics,
  },
};
